module.exports = __webpack_public_path__ + "74bfa2bc6dc1fe9f71761db6232a19cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/theme-files/image-resources/poly-bg/poly-bg-10.jpg
// module id = 399
// module chunks = 0